import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { getIsoTimestamp } from "../../utils/analyics/analyticsHelper";

type PageViewState = {
  path: string | null;
  status: "idle" | "ready";
  data: any;
};

const initialState: PageViewState = {
  path: null,
  status: "idle",
//   enteredAt: "",
  data: {},
};

const pageViewSlice = createSlice({
  name: "pageView",
  initialState,
  reducers: {
    pageEntered(state, action: PayloadAction<string>) {
      state.path = action.payload;
      state.status = "idle";
      state.data = {};
    },
    pageReady(state, action: PayloadAction<Record<string, any>>) {
      state.data = action.payload;
      state.status = "ready";
    },
    pageTracked(state) {
        state.status = "idle"; 
    },
  },
});

export const {
  pageEntered,
  pageReady,
  pageTracked,
} = pageViewSlice.actions;

export default pageViewSlice.reducer;
